import React from "react";
import { Box, Typography } from "@mui/material";
import moment from "moment";
import CreditBalanceCard from "./CreditBalanceCard";
import PurchaseHistoryTable from "./PurchaseHistoryTable";
import SubscriptionHistoryTable from "./SubscriptionHistoryTable";
import TopUpCreditsModal from "./TopUpCreditsModal";
import PaymentStatusModal from "./PaymentStatusModal";
import useCreditWallet from "../../hooks/useCreditWallet";

/**
 * InterpretationCredits
 * Content for the Settings > "Interpretation & Credits" tab.
 * Shows the balance card, the plan assignment (subscription) history and
 * the purchase history table together, stacked on the same page.
 */
const InterpretationCredits = () => {
  const {
    loading,
    credits,
    isUnlimitedCredits,
    currentPlan,
    pricePerCredit,
    planLogs,
    canTopUp,
    purchaseHistory,
    topUpOpen,
    openTopUp,
    closeTopUp,
    paying,
    handlePayTopUp,
    statusModal,
    closeStatusModal,
    downloadInvoice,
    retryTopUp,
  } = useCreditWallet();

  const planHistory = planLogs.map((log) => ({
    id: log._id || log.id,
    dateTime: log.created_at
      ? moment(Number(log.created_at)).format("DD MMM YYYY, hh:mm A")
      : "-",
    planName: log.plan_name || "-",
    interpretationLimit: log.interpretation_limit ?? "-",
    centerLimit: log.center_limit ?? "-",
    userLimit: log.user_limit ?? "-",
    assignedBy: log.created_by?.name || "-",
  }));

  return (
    <Box>
      <CreditBalanceCard
        credits={credits}
        isUnlimited={isUnlimitedCredits}
        isMigrated={currentPlan?.isMigrated === true}
        planName={currentPlan?.planName || currentPlan?.identifier}
        pricePerCredit={pricePerCredit}
        canTopUp={canTopUp}
        onTopUpClick={openTopUp}
      />

      <Box sx={{ marginTop: "24px" }}>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 700,
            color: "#22223b",
            marginBottom: "12px",
          }}
        >
          Plan Assignment History
        </Typography>

        <SubscriptionHistoryTable logs={planHistory} loading={loading} />
      </Box>

      {!isUnlimitedCredits && (
        <Box sx={{ marginTop: "24px" }}>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 700,
              color: "#22223b",
              marginBottom: "12px",
            }}
          >
            Purchase History
          </Typography>

          <PurchaseHistoryTable
            transactions={purchaseHistory}
            onDownloadInvoice={downloadInvoice}
          />
        </Box>
      )}

      <TopUpCreditsModal
        open={topUpOpen}
        onClose={closeTopUp}
        mode="topUp"
        currentBalance={credits}
        pricePerCredit={pricePerCredit}
        loading={paying}
        onPayTopUp={handlePayTopUp}
      />

      <PaymentStatusModal
        open={statusModal.open}
        onClose={closeStatusModal}
        status={statusModal.status}
        data={statusModal.data}
        onPrimaryAction={retryTopUp}
        onSecondaryAction={closeStatusModal}
      />
    </Box>
  );
};

export default InterpretationCredits;
